import React, {useEffect, useState} from 'react';
import {View, StyleSheet, Text, Animated, TouchableOpacity} from 'react-native';

import {Header, Days} from './index';
import {useCalendar} from '../DatePicker';
import {moderateScale} from '../../../../tools/Scaling';
import * as Colors from '../../../../tools/Colors';
import HMTextView from '../../../HMTextView';
import i18n from '../../../../I18n/i18n';
import {getFormatedDate} from '../../index';

const Calendar = (props) => {
    const {options, state, utils, onSelectedChange, onDateChange, onSelectedDateFinal, onBackdropPress} = useCalendar();
    const [mainState, setMainState] = state;
    const style = styles(options);
    const [{shownAnimation}, changeMonthAnimation] = utils.useMonthAnimation(
        mainState.activeDate,
        options.daysAnimationDistance,
    );
    //const [selectedOrdinalState, setSelctedOrginalState]  = useState(props.selected);
    let selectedOrdinalState=null;
    //////////////
    const onSelectDay = date => {
        setMainState({
            type: 'set',
            selectedDate: date,
            activeDate: date,


        });
        onDateChange(utils.getFormated(utils.getDate(date), 'dateFormat'));
        // setMainState({
        //     type: 'set',
        //     activeDate: utils.getFormated(newDate),
        // });
    };
/////////////
    useEffect(() => {

            mainState.selectedDate && onSelectedChange(mainState.selectedDate);
        },
        //  [mainState.selectedDate, onSelectedChange]
        [mainState.selectedDate],
    );
    useEffect(() => {
        props.selected && onSelectedChange(props.selected);
       props.selected && onSelectDay(props.selected);
     //  props.selected && onSelectDay(getFormatedDate(props.selected, 'jYYYY/jMM/jDD'));

        // selectedOrdinalState = props.selected;

        // console.log(
        //     "Occurs ONCE, AFTER the initial render."
        // );
    }, []);

    // useEffect(() => {
    //
    //         props.selected && onSelectedChange(props.selected);
    //     },
    //     //  [mainState.selectedDate, onSelectedChange]
    //     [ props.selected],
    // );

    return (
        <View style={style.container}>
            <Header changeMonth={changeMonthAnimation}/>
            <View style={[style.daysName, utils.flexDirection]}>
                {utils.config.dayNamesShort.map(item => (
                    <Text key={item} style={style.daysNameText}>
                        {item}
                    </Text>
                ))}
            </View>
            <View style={style.daysContainer}>
                <Animated.View style={[{
                    width: '100%',
                    //backgroundColor:"#005eee"
                }, style.days, shownAnimation]}>
                    <Days/>
                </Animated.View>

            </View>

            <View
                style={{
                    flexDirection: 'row',
                    marginVertical: moderateScale(10),
                    justifyContent: 'space-between',
                    paddingHorizontal: moderateScale(4),
                }}>
                <TouchableOpacity
                    style={{
                        backgroundColor: Colors.green,
                        width: '32%',
                        height: moderateScale(40),
                        alignItems: 'center',
                        justifyContent: 'center',
                        // borderRadius:moderateScale(2)
                    }}

                    onPress={() => {
                        onSelectedDateFinal(mainState.selectedDate);
                    }}

                >
                    <View
                        style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <HMTextView type={'bold'} text={'تایید'} style={{
                            color: 'white',
                            fontSize: moderateScale(16),
                            // marginEnd: moderateScale(10)
                        }}/>

                    </View>
                </TouchableOpacity>
                <TouchableOpacity style={{
                    backgroundColor: Colors.yellow,
                    width: '32%',
                    height: moderateScale(40),
                    alignItems: 'center',
                    justifyContent: 'center',
                    // borderRadius:moderateScale(2)
                }}
                                  onPress={() => {
                                      onSelectDay(getFormatedDate(new Date(), 'jYYYY/jMM/jDD'));
                                  }}

                >
                    <View
                        style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <HMTextView type={'bold'} text={'برو به امروز'} style={{
                            color: 'white',
                            fontSize: moderateScale(16),
                            //marginEnd: moderateScale(10)
                        }}/>

                    </View>
                </TouchableOpacity>

                <TouchableOpacity style={{
                    backgroundColor: Colors.red,
                    width: '32%',
                    height: moderateScale(40),
                    alignItems: 'center',
                    justifyContent: 'center',
                    // borderRadius:moderateScale(2)
                }}
                                  onPress={() => {
                                      onBackdropPress();
                                  }}

                >
                    <View
                        style={{
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <HMTextView type={'bold'} text={i18n.t('constant.Back')} style={{
                            color: 'white',
                            fontSize: moderateScale(16),
                            // marginEnd: moderateScale(10)
                        }}/>

                    </View>
                </TouchableOpacity>
            </View>
        </View>
    );
};

const styles = theme =>
    StyleSheet.create({
        container: {
            flexDirection: 'column',
            flex: 1,
        },
        daysName: {
            paddingBottom: 10,
            marginBottom: 0,
            alignItems: 'center',
            justifyContent: 'space-around',
            borderBottomColor: theme.borderColor,
            borderBottomWidth: 1,
            marginHorizontal: 15,
        },
        daysNameText: {
            fontFamily: theme.defaultFont,
            color: theme.textSecondaryColor,
            fontSize: theme.textFontSize,
        },
        daysContainer: {
            flex: 1,
            // width: "92%",
            position: 'relative',
            overflow: 'hidden',
            margin: 5,
            marginTop: 5,
            marginBottom: 0,
            // backgroundColor:"#ee313d"

        },
        days: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            right: 0,
        },
    });

export {Calendar};
